import * as _ from "lodash";
import PropTypes from "prop-types";
import React from "react";
import { AccordionSingle } from "../../../common/components/accordion/AccordionSingle";
import { faqAccordionItemType } from "../../../common/types";
import { FaqItem } from "./FaqItem";

export function Faq({ items }) {
	if (items.length === 0) {
		return null;
	}

	const list = items.map((item) => (
		<FaqItem key={_.camelCase(item.title)} item={item} />
	));

	return (
		<section className="section--faq">
			<div className="container">
				<p className="section-title">Frequently asked questions</p>
				<AccordionSingle items={list} />
			</div>
		</section>
	);
}

Faq.propTypes = {
	items: PropTypes.arrayOf(faqAccordionItemType).isRequired,
};
